import { render, staticRenderFns } from "./CustomCollapse.vue?vue&type=template&id=33534aa3&scoped=true"
import script from "./CustomCollapse.vue?vue&type=script&lang=js"
export * from "./CustomCollapse.vue?vue&type=script&lang=js"
import style0 from "./CustomCollapse.vue?vue&type=style&index=0&id=33534aa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33534aa3",
  null
  
)

export default component.exports